import { Box, Typography } from '@mui/material';
import { Image } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import CommunityDevice from '@/types/database/communityDevice';

const RecordDescription: React.FC<{ record: CommunityDevice | null }> = ({
  record,
}) => {
  const [data, setData] = useState<
    {
      label: string;
      value: any;
    }[]
  >([]);

  useEffect(() => {
    if (record) {
      setData([
        {
          label: '建立時間',
          value: moment(record.createdTime).format('YYYY-MM-DD'),
        },
        {
          label: '設備名稱',
          value: record.deviceName,
        },
        {
          label: '設備編號',
          value: record.deviceNumber,
        },
        {
          label: '保管人',
          value: record.deviceKeeper,
        },
        {
          label: '保管位置',
          value: record.deviceStorePlace,
        },
        {
          label: '購入日期',
          value: moment(record.deviceDate).format('YYYY-MM-DD'),
        },
        {
          label: '設備年限',
          value: `${record.deviceYear}年`,
        },
        {
          label: '設備價值',
          value: `${record.deviceMoney}元`,
        },
        {
          label: '設備廠商',
          value:
            record.deviceVendor.length > 0
              ? record.deviceVendor.map((list) => {
                  return (
                    <p style={{ margin: 0 }} key={list.id}>
                      {list.name}
                    </p>
                  );
                })
              : '',
        },
        {
          label: '設備規範',
          value:
            record.specification !== undefined ? (
              <a href={record.specification.path} target="blank">
                {record.specification.name}
              </a>
            ) : (
              '無規範'
            ),
        },
        {
          label: '設備圖片',
          value: record?.files?.path ? (
            <Image
              width={200}
              // height={200}
              src={record.files.path}
              alt="圖片"
            />
          ) : (
            '無圖片'
          ),
        },
        {
          label: '設備狀態',
          value: record.status,
        },
      ]);
    }
  }, [record]);
  return (
    <Box
      sx={{
        height: '600px',
        width: '500px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      {data.length > 0 &&
        data.map((i) => (
          <Box>
            <Typography
              sx={{
                color: ' rgb(102, 102, 102)',
                fontSize: '14px',
                lineHeight: '32px',
              }}
            >
              {i.label}
            </Typography>
            <Box
              sx={{
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '24px',
              }}
            >
              {i.value}
            </Box>
          </Box>
        ))}
    </Box>
  );
};

export default RecordDescription;
